module.exports = __webpack_public_path__ + "img/logo-congreso.12235337.png";